import React from 'react'
import { Form } from 'react-bootstrap'
import { Controller, useForm } from 'react-hook-form'
import PhoneInput from 'react-phone-input-2'
import { useEditProfileMutation, useGetProfileQuery } from '../../../redux/services/ProfileService'
import { responseError } from '../../../helpers/responseHandler'
import { convertToFormData, sweetAlert } from '../../../utils'
import LoadingButtonWithForm from '../../../components/LoadingButtonWithForm'
import GlobalLoading from '../../../components/GlobalLoading'

const UpdateProfile = () => {
    let {
        control,
        register,
        handleSubmit,
        setValue,
        watch,
        reset,
        formState: { errors },
    } = useForm()

    const [editRequest, { isLoading: editLoading }] = useEditProfileMutation()

    const { data: data2, isLoading, isFetching, refetch } = useGetProfileQuery()
    const isEdit = data2?.response?.data

    const onSubmit = async (data) => {
        const newForm = convertToFormData(data)
        await editRequest(newForm).unwrap()
            .then((res) => {
                if (res?.status) {
                    sweetAlert(res?.message, 'success')
                }
            })
            .catch((err) => {
                responseError(err)
            })
    }
    return (
        <>
            {(isLoading || isFetching) ? <GlobalLoading /> : (
                <>
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="">
                                <div className="p-5">
                                    <div className="mb-4 main-content-label">
                                        Personal Information
                                    </div>
                                    <Form onSubmit={handleSubmit(onSubmit)} className="form-horizontal" id='profile-status'>

                                        {/* <div className="mb-4 main-content-label">Name</div> */}
                                        <div className="form-group ">
                                            <div className="row">
                                                <div className="col-md-2">
                                                    <label className="form-label">NAME</label>
                                                </div>
                                                <div className="col-md-10">
                                                    <Controller
                                                        name="name"
                                                        control={control}
                                                        defaultValue={isEdit?.name || ''}
                                                        rules={{
                                                            required: true
                                                        }}
                                                        render={({ field }) => (
                                                            <Form.Control
                                                                {...field}
                                                                type="text"
                                                                placeholder="Enter Name"
                                                                isInvalid={errors.name}
                                                            />
                                                        )}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group ">
                                            <div className="row">
                                                <div className="col-md-2">
                                                    <label className="form-label">EMAIL</label>
                                                </div>
                                                <div className="col-md-10">
                                                    <Form.Control
                                                        type="email"
                                                        placeholder="Enter Email"
                                                        defaultValue={isEdit?.email || ''}
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group ">
                                            <div className="row">
                                                <div className="col-md-2">
                                                    <label className="form-label">PHONE NUMBER</label>
                                                </div>
                                                <div className="col-md-10">
                                                    <Controller
                                                        name="phone"
                                                        control={control}
                                                        defaultValue={isEdit?.phone || ''}
                                                        rules={{
                                                            required: false
                                                        }}
                                                        render={({ field }) => (
                                                            <PhoneInput
                                                                {...field}
                                                                country={'us'} // Default country
                                                                inputProps={{
                                                                    name: 'phone',
                                                                    required: true,
                                                                    autoFocus: true,
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group ">
                                            <div className="row">
                                                <div className="col-md-2">
                                                    <label className="form-label">Profile</label>
                                                </div>
                                                <div className="col-md-10">
                                                    <Controller
                                                        name="avatar"
                                                        control={control}
                                                        defaultValue={''}
                                                        rules={{
                                                            required: false
                                                        }}
                                                        render={({ field }) => (
                                                            <Form.Control
                                                                onChange={(e) => field.onChange(e.target.files[0])}
                                                                type="file"
                                                                isInvalid={errors.avatar}
                                                            />
                                                        )}
                                                    />
                                                    {isEdit?.avatar && (
                                                        <img src={isEdit?.avatar_url} alt="profile" width={80} />
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group ">
                                            <div className="row">
                                                <div className="col-md-2">
                                                    <label className="form-label">Company Logo</label>
                                                </div>
                                                <div className="col-md-10">
                                                    <Controller
                                                        name="company_logo"
                                                        control={control}
                                                        defaultValue={''}
                                                        rules={{
                                                            required: false
                                                        }}
                                                        render={({ field }) => (
                                                            <Form.Control
                                                                onChange={(e) => field.onChange(e.target.files[0])}
                                                                type="file"
                                                                placeholder="Enter Phone No"
                                                                isInvalid={errors.company_logo}
                                                            />
                                                        )}
                                                    />
                                                    {isEdit?.company_logo && (
                                                        <img src={isEdit?.company_logo_url} alt="company_logo" width={80} />
                                                    )}
                                                </div>
                                            </div>
                                        </div>


                                    </Form>

                                </div>
                                <div className="card-footer d-flex justify-content-end">
                                    <button
                                        type="button"
                                        className="btn ripple btn-light w-sm me-2"
                                    >
                                        Cancel
                                    </button>
                                    <LoadingButtonWithForm
                                        isLoading={editLoading}
                                        name="Save"
                                        form="profile-status"
                                    />
                                </div>
                            </div>
                        </div>
                    </div >
                </>
            )}
        </>
    )
}

export default UpdateProfile